import React from 'react';
import './LegalPages.css';

function Pricing() {
  const plans = [
    {
      id: "instant",
      name: "Quick Start",
      duration: "24 Hours",
      idealFor: "One-time tasks and urgent projects",
      description: "Perfect for quick document tasks. Full access to all AI tools for 24 hours.",
      features: [
        "24-hour unlimited access",
        "AI document summarization",
        "Smart Q&A with PDFs",
        "Document translation",
        "Voice reader & audio export",
        "PDF editing & conversion",
        "Split, merge & compress",
        "Files up to 100MB",
        "No watermarks",
        "Email support",
      ],
      price: 14.99,
      isOneTime: true,
    },
    {
      id: "flex",
      name: "Flex Plan",
      duration: "2 Weeks",
      idealFor: "Short-term projects and students",
      description: "Extended access for projects, exams, or temporary needs.",
      features: [
        "14-day unlimited access",
        "Complete AI document suite",
        "Advanced summarization",
        "Multi-language translation",
        "Voice reader with speed control",
        "Professional PDF editing",
        "Batch processing",
        "Files up to 100MB",
        "Priority email support",
        "Mobile app access",
      ],
      price: 24.99,
    },
    {
      id: "pro",
      name: "Pro Monthly",
      duration: "Monthly",
      idealFor: "Professionals and regular users",
      description: "Best value for ongoing work. Everything you need for productive workflows.",
      features: [
        "Unlimited monthly access",
        "Advanced AI features",
        "Priority processing",
        "Custom templates",
        "Advanced analytics",
        "Files up to 200MB",
        "Live chat support",
        "Weekly feature updates",
      ],
      popular: true,
      price: 49.99,
    },
  ];

  const formatPrice = (plan) => {
    return `€${plan.price.toFixed(2)}`;
  };

  const getBillingText = (plan) => {
    if (plan.isOneTime) return "one-time (24h access)";
    if (plan.id === "flex") return "for 14 days";
    if (plan.id === "pro") return "per month";
    return "";
  };

  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="legal-header-content">
          <h1>Simple, Transparent Pricing</h1>
          <p>Choose the perfect plan for your workflow. No hidden fees, cancel anytime.</p>
          <div style={{ 
            display: 'flex', 
            gap: '20px', 
            marginTop: '20px', 
            flexWrap: 'wrap',
            justifyContent: 'center',
            fontSize: '14px'
          }}>
            <span style={{ color: '#10b981', fontWeight: '600' }}>✓ 30-Day Money Back</span>
            <span style={{ color: '#10b981', fontWeight: '600' }}>✓ Cancel Anytime</span>
            <span style={{ color: '#10b981', fontWeight: '600' }}>✓ Secure Payment</span>
          </div>
        </div>
      </div>

      <div className="legal-container">
        <div className="legal-content">
          {/* Pricing Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '30px',
            marginBottom: '50px'
          }}>
            {plans.map((plan) => (
              <div
                key={plan.id}
                style={{
                  background: plan.popular 
                    ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                    : 'white',
                  border: plan.popular ? 'none' : '2px solid #e5e7eb',
                  borderRadius: '16px',
                  padding: '32px 24px',
                  position: 'relative',
                  color: plan.popular ? 'white' : '#1f2937',
                  boxShadow: plan.popular 
                    ? '0 20px 40px rgba(102, 126, 234, 0.3)'
                    : '0 4px 6px rgba(0, 0, 0, 0.05)',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  cursor: 'pointer',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = plan.popular
                    ? '0 24px 48px rgba(102, 126, 234, 0.4)'
                    : '0 12px 24px rgba(0, 0, 0, 0.1)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = plan.popular
                    ? '0 20px 40px rgba(102, 126, 234, 0.3)'
                    : '0 4px 6px rgba(0, 0, 0, 0.05)';
                }}
              >
                {plan.popular && (
                  <div style={{
                    position: 'absolute',
                    top: '-12px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                    color: 'white',
                    padding: '6px 20px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: '700',
                    letterSpacing: '0.5px',
                    boxShadow: '0 4px 12px rgba(251, 191, 36, 0.4)',
                  }}>
                    MOST POPULAR
                  </div>
                )}

                <h3 style={{ 
                  fontSize: '24px', 
                  fontWeight: '700', 
                  marginBottom: '8px',
                  color: plan.popular ? 'white' : '#1f2937'
                }}>
                  {plan.name}
                </h3>
                
                <div style={{ 
                  fontSize: '14px', 
                  opacity: 0.9,
                  marginBottom: '12px',
                  fontWeight: '600'
                }}>
                  {plan.duration}
                </div>

                <div style={{ 
                  fontSize: '42px', 
                  fontWeight: '800', 
                  marginBottom: '8px',
                  color: plan.popular ? 'white' : '#667eea'
                }}>
                  {formatPrice(plan)}
                </div>
                
                <div style={{ 
                  fontSize: '14px', 
                  opacity: 0.8,
                  marginBottom: '16px'
                }}>
                  {getBillingText(plan)}
                </div>

                {!plan.isOneTime && (
                  <div style={{
                    background: plan.popular ? 'rgba(255,255,255,0.2)' : 'rgba(102, 126, 234, 0.1)',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    fontSize: '13px',
                    fontWeight: '600',
                    marginBottom: '16px',
                    textAlign: 'center'
                  }}>
                    Start with €0.01 trial (24h)
                  </div>
                )}

                <div style={{ 
                  fontSize: '14px', 
                  fontWeight: '600',
                  marginBottom: '8px',
                  opacity: 0.9
                }}>
                  {plan.idealFor}
                </div>

                <div style={{ 
                  fontSize: '14px', 
                  opacity: 0.85,
                  marginBottom: '24px',
                  lineHeight: '1.6'
                }}>
                  {plan.description}
                </div>

                <a 
                  href="/lp/xbt1l"
                  style={{
                    display: 'block',
                    width: '100%',
                    padding: '14px',
                    background: plan.popular ? 'white' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: plan.popular ? '#667eea' : 'white',
                    textAlign: 'center',
                    borderRadius: '10px',
                    textDecoration: 'none',
                    fontWeight: '700',
                    fontSize: '16px',
                    marginBottom: '24px',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.2)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
                  }}
                >
                  {plan.isOneTime ? 'Start Now' : plan.id === 'flex' ? 'Get 2 Weeks' : 'Go Pro'}
                </a>

                <ul style={{ 
                  listStyle: 'none', 
                  padding: 0, 
                  margin: 0,
                  fontSize: '14px'
                }}>
                  {plan.features.map((feature, index) => (
                    <li key={index} style={{ 
                      padding: '8px 0', 
                      display: 'flex', 
                      alignItems: 'flex-start',
                      opacity: 0.9
                    }}>
                      <span style={{ 
                        marginRight: '10px',
                        color: plan.popular ? '#fbbf24' : '#10b981',
                        fontWeight: 'bold',
                        fontSize: '16px'
                      }}>✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Additional Info Sections */}
          <section className="content-section">
            <h2>All Plans Include</h2>
            <ul>
              <li>Secure document processing with end-to-end encryption</li>
              <li>Automatic file deletion after processing</li>
              <li>GDPR compliant data handling</li>
              <li>Multiple output formats</li>
              <li>Cloud storage integration</li>
              <li>Mobile-friendly interface</li>
              <li>Regular feature updates</li>
            </ul>
          </section>

          <section className="content-section">
            <h2>Money-Back Guarantee</h2>
            <p>
              We stand behind our service with a 30-day money-back guarantee. If you're not 
              completely satisfied with your subscription, contact us within 30 days of purchase 
              for a full refund. No questions asked.
            </p>
          </section>

          <section className="content-section">
            <h2>Billing Information</h2>
            <p>
              All subscriptions are billed as shown. Pro Monthly plans can be cancelled anytime 
              from your account dashboard. Annual plans receive significant savings compared to 
              monthly billing.
            </p>
            <p>
              Payment is processed securely through our payment partners. We accept all major 
              credit cards, PayPal, Apple Pay, Google Pay, and other local payment methods 
              depending on your region.
            </p>
          </section>

          <section className="content-section">
            <h2>Frequently Asked Questions</h2>
            
            <h3>Can I try before I buy?</h3>
            <p>
              Yes! Monthly and 2-week plans start with a €0.01 trial period for 24 hours. 
              You can test all features before being charged the full amount.
            </p>

            <h3>Can I cancel anytime?</h3>
            <p>
              Absolutely. You can cancel your subscription at any time from your account dashboard. 
              No questions asked, no cancellation fees.
            </p>

            <h3>What payment methods do you accept?</h3>
            <p>
              We accept Visa, Mastercard, PayPal, Apple Pay, Google Pay, and various local 
              payment methods depending on your region.
            </p>

            <h3>Is there a refund policy?</h3>
            <p>
              Yes, we offer a 30-day money-back guarantee on all plans. If you're not satisfied, 
              contact us for a full refund within 30 days of purchase.
            </p>
          </section>

          <section className="content-section">
            <h2>Ready to Get Started?</h2>
            <p>
              Choose the plan that's right for you and start transforming your document workflow today.
            </p>
            <div style={{ marginTop: '30px', textAlign: 'center' }}>
              <a 
                href="/lp/xbt1l" 
                className="cta-button"
                style={{
                  display: 'inline-block',
                  padding: '15px 40px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '16px',
                  transition: 'transform 0.2s',
                }}
                onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
              >
                Subscribe Now
              </a>
            </div>
          </section>

          <section className="content-section">
            <h2>Contact Us</h2>
            <p>
              Have questions about our pricing? Our team is here to help you choose the right plan.
            </p>
            <p>
              <strong>Email:</strong> help@docuaihub.com<br />
              <strong>Phone:</strong> +357 77788373
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Pricing;
